var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bq-advantage"},_vm._l((_vm.advantages),function(item){return _c('InfoBox',{key:item.advTitles,attrs:{"itemObj":item,"col":3,"classes":'advantage'}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }